import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { Dashboard_Lists_AnstehendeZahlungDetailsBlock_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { list_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Msg, Model } from "./Types.fs.js";
import { GlobalMsg, GlobalMessageBox_Error_Z721C83C5 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";

export function Http_getData(_arg) {
    const response = fetch("/api/dashboard/anstehende-zahlung-list", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(Dashboard_Lists_AnstehendeZahlungDetailsBlock_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function State_init(_arg, _arg_1, _arg_2) {
    return [new Model(true, empty()), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    let msg_1;
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                return [new Model(false, empty()), (msg_1 = (new Msg(2, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Die Daten können zur Zeit leider nicht geladen werden.")])])), singleton((dispatch) => {
                    dispatch(msg_1);
                }))];
            }
            else {
                return [new Model(false, msg.fields[0].fields[0]), Cmd_none()];
            }
        case 2:
            return [model, Cmd_none()];
        default:
            return [new Model(true, empty()), request(() => Http_getData(undefined), undefined, (Item) => (new Msg(1, [Item])))];
    }
}

//# sourceMappingURL=State.fs.js.map
